import { CheckCircle2, Clock, Mail } from "lucide-react";
import { fmtDateLong } from "@/lib/constants";
import { PendingBadge } from "@/components/Brand";

export function ThankYou({ result, onReset }) {
  return (
    <section className="brut-card brut-shadow overflow-hidden fade-up" data-testid="thank-you-screen">
      <div className="border-b-2 border-black bg-[#FACC15] px-6 py-8 sm:px-10">
        <CheckCircle2 className="h-12 w-12" strokeWidth={2.5} />
        <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          {result.duplicate ? "You have already raised this query." : "Thank you, your query has been received."}
        </h1>
        {result.duplicate && (
          <p className="mt-3 text-base font-semibold" data-testid="duplicate-notice">
            Our team is working on it, please have a little patience. We've flagged your ticket so it's picked up faster (re-submitted {result.resubmit_count}×).
          </p>
        )}
      </div>
      <div className="space-y-6 px-6 py-8 sm:px-10">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">Your Ticket No is</p>
          <p className="mt-2 inline-block rounded-xl border-2 border-black bg-black px-5 py-3 font-mono text-3xl font-bold text-[#FACC15] sm:text-4xl" data-testid="ticket-id-badge">
            {result.ticket_id}
          </p>
        </div>
        <div className="flex items-start gap-3 rounded-xl border-2 border-black bg-[#FEF9C3] p-4">
          <Clock className="mt-0.5 h-6 w-6 shrink-0" />
          <p className="text-base sm:text-lg">
            Our team will resolve it by <strong data-testid="sla-due-date">{fmtDateLong(result.sla_due_at)}</strong>.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3 text-base text-zinc-700">
          <Mail className="h-5 w-5" />
          <span>You will be updated on your email.</span>
          <PendingBadge label={result.notifications === "sent" ? "Confirmation email sent" : "Confirmation email queued"} testId="notify-pending-badge" />
        </div>
        <p className="text-sm text-zinc-500">Please save your ticket number. Quote it in any follow-up, or use "Check ticket status" at the top of this page anytime.</p>
        <button type="button" onClick={onReset} className="btn-dark" data-testid="submit-another-button">
          Submit another query
        </button>
      </div>
    </section>
  );
}
